import { createFileRoute } from '@tanstack/react-router';
import { EditMemberPage } from '../components/pages/BusinessPage/EditMemberPage';

export const Route = createFileRoute('/account/members_/$customerId_/edit')({
  component: EditMemberPage,
});
